import {
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';

import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Router } from '@angular/router';
import { WidgetDataStore } from '../../../../stores';
import { ListWidget, ListWidgetData, WidgetListItem } from '../../models';

@Component({
  selector: 'siat-list-widget',

  imports: [
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    NgClass,
  ],
  templateUrl: './list-widget.component.html',
  styleUrl: './list-widget.component.scss',
})
export class ListWidgetComponent {
  @Input() widget!: ListWidget;
  @Input() lockedPatient: boolean;
  @Output() loadMore = new EventEmitter<ListWidget>();

  private widgetDataStore = inject(WidgetDataStore);
  private router = inject(Router);

  get labels(): string[] {
    return this.widget?.config?.labels || [];
  }

  // Get widget data from store reactively
  listData = computed(() => {
    const data = this.widgetDataStore.getWidgetData(this.widget?.id);
    return (
      (data as ListWidgetData) || { items: [], totalCount: 0, hasMore: false }
    );
  });

  onItemClick(item: WidgetListItem) {
    this.router.navigateByUrl(
      `/home/${this.widget.config.path.detail}${item.id}`
    );
  }

  trackByItemId(_index: number, item: WidgetListItem): string {
    return item.id;
  }
}
